// eslint-disable-next-line no-restricted-imports
import {GetMerchantInfoForProductSizeResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/merchant_info/v1/service.types';
import {FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {USPsView} from '../ArticleDetail/USPs/USPsView';

export const MerchantLegalInfoContent: FC<
  GetMerchantInfoForProductSizeResponse & {className?: string}
> = ({merchantInfo, className}) => {
  return (
    <LegalContentWrapper className={className}>
      <MainHeadline>{merchantInfo.headline}</MainHeadline>

      <AddressBlock>
        {merchantInfo.address.lines.map((line, index) => {
          return <div key={`line-${index}`}>{line}</div>;
        })}
      </AddressBlock>

      {merchantInfo.uspSection && (
        <USPBlock>
          <USPTitle>{merchantInfo.uspSection?.headline}</USPTitle>
          <USPsView usps={merchantInfo.uspSection.usps} articleUsps={[]} />
        </USPBlock>
      )}

      {merchantInfo.detailSections.map((detail, index) => {
        return (
          <DetailsBlock key={`detail-${index}`}>
            <DetailsTitle>{detail.headline}</DetailsTitle>
            {detail.values.map((detailValue, valueIndex) => (
              <div key={`detail-value-${index}-${valueIndex}`}>
                {detailValue}
              </div>
            ))}
          </DetailsBlock>
        );
      })}
    </LegalContentWrapper>
  );
};

const MainHeadline = styled.div`
  font-size: ${FONT_SIZES.px18};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  margin-bottom: 16px;
`;

const AddressBlock = styled.div`
  margin-bottom: 32px;
`;

const USPBlock = styled.div`
  margin-bottom: 32px;
`;

const USPTitle = styled.div`
  margin-bottom: 8px;
`;

const DetailsBlock = styled.div``;

const DetailsTitle = styled.div`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.heavy};
`;

const LegalContentWrapper = styled.div`
  line-height: 20px;
  font-size: ${FONT_SIZES.px14};

  ${DetailsBlock} {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;
